export namespace ProfileManagement {
  export const MIN_PASSWORD_LENGTH: number = 6;
  export const SPECIAL_CHARACTERS: string = '!@#$%^';
  export const passwordDescription: string =
    'Password must contain at least one uppercase letter, at least one digit, at least one special character (' +
    SPECIAL_CHARACTERS +
    '), and be at least six characters in length.';
  export const passwordRegEx =
    '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[' +
    SPECIAL_CHARACTERS +
    ']).{6,}$';

  /**
   * Generate random string based on length
   *
   * @param length
   */
  export const generateRandomString = (length: number): string => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' +
      SPECIAL_CHARACTERS;
    const charactersLength = characters.length;
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };
}
